import { getHttpClient, unwrapContainer } from '@/api/client/http-client';
import type {
  NAInterfaceResponseObj,
  AccountDevicesInfoRespObj,
  DeviceInfoReqObj,
  DeviceInfoRespObj,
  DevicePropertiesReqObj,
} from '@/api/models';

export async function getAccountDevices(
  accountUUID: string,
): Promise<AccountDevicesInfoRespObj> {
  const client = getHttpClient();
  const response = await client.post<NAInterfaceResponseObj>(
    '/Devices/AccountDevices',
    { accountUUID },
  );
  return unwrapContainer<AccountDevicesInfoRespObj>(response.data);
}

export async function getDeviceInfo(
  req: DeviceInfoReqObj,
): Promise<DeviceInfoRespObj> {
  const client = getHttpClient();
  const response = await client.post<NAInterfaceResponseObj>(
    '/Devices/DeviceInfo',
    req,
  );
  return unwrapContainer<DeviceInfoRespObj>(response.data);
}

export async function setDeviceProperties(
  req: DevicePropertiesReqObj,
): Promise<NAInterfaceResponseObj> {
  const client = getHttpClient();
  const response = await client.post<NAInterfaceResponseObj>(
    '/Devices/DeviceProperties',
    req,
  );
  return response.data;
}
